var Raphael = require('raphael'),
    ShapeModel = require('./baseShape'),
      _ = require('underscore');


module.exports = ShapeModel.extend({

    DISABLED_RAPHAEL_ATTRS:  {
        opacity: 0.5
    },
    ENABLED_RAPHAEL_ATTRS: {
        opacity: 1.0
    },
    /*
    * Base shape attrs don't apply here; these are the Raphael attributes.
    * Store the attributes on this.origSVGAttrs.
    * */
    parse: function( raphaelAttrs, options ) {

        /*
        * Note: origSVGAttrs not set if shape isNewlyDrawn in current workflow (shouldn't matter)
        * Could make this a model attribute now.
        * */
        this.origSVGAttrs = raphaelAttrs;

        /*
        * Call parse on baseShape to set instance variables but return none for this shape type.
        * Invoke for flexibility and to set instance variables.
        * Note: need to pass in attributes for anything set based on raphaelAttrs.
        * When refactor: move everything from the shapeModel parses to the constructor.
        * */
        var attrs = ShapeModel.prototype.parse.apply(this, arguments);

        /* Only return the uid -- now that we are using that*/
        return {
            uid: attrs.uid
        };

    },

    /*
    * All the shape types have a stroke except signatures (they use fill)
    * May be better to store as custom attribute in the SVG
    * For now not an issue for signatures because their color can't be over-written
    *
    * This could later be broken up using a fn ala 'getZoneColorOnParse' but,
    * for now I think code is clearer having the logic in one place;
    * and especially in case I start storing a color custom attribute and/or
    * I implement the ability to change signature note color.
    * Note: now subclassed for text stamp;
    * TODO: break this up now that it's already different for text stamp
    * */
    setZoneColorOnParse: function( raphaelAttrs, options ) {

        var isSignature =
            options.parentNote.isSignature();

        var color = !options.isNewlyDrawn

            ? isSignature
                ? raphaelAttrs.fill
                : raphaelAttrs.stroke

            : isSignature
                // now they are all black -- quick hack in lieu of letting user change their color
                ? options.parentNote.getDefaultShapeColor()
                /*
                 * The visible color of the shape may have been overridden.
                 * set from currentDrawingAttributes --- it must have been created with this color
                 * ( also, no raphael attributes are passed in here ).
                 * */
                : options.channel.request('getCurrentDrawingAttributes').color; // for newly drawn notes, options.channel is passed in

        this.setZoneColor( color );

    },

    /**
     * Secondary enabled/disabled ... of other graphic notes other than active one on same canvas.
     * TODO: put this on the ui model / view
     */
    setDisabled: function() {
        var ui = this.uiModel,
            rEl = ui.raphaelEl(),
            lastAttrs = rEl.attrs,
            newAttrs = _.extend( {}, lastAttrs, this.DISABLED_RAPHAEL_ATTRS);
        ui.lastAttrs = lastAttrs;
        ui.raphaelEl().attr(newAttrs);
    },
    setEnabled: function() {
        var ui = this.uiModel;
        ui.raphaelEl().attr( _.extend({}, ui.lastAttrs, this.ENABLED_RAPHAEL_ATTRS) );
         _.omit(ui, 'lastAttrs');
    },

    getNormalizedElToPerist: function() {

        var el = this.uiModel.get('raphaelEl'),
            path = Raphael.fn.viewerUnadjustedPath.apply( Raphael.fn, [el.attr('path')].concat( _.toArray(arguments)) ),
            clone = el.clone();

        clone.attr('path', path);
        clone.attrs =  _.omit(clone.attrs, 'cursor'); // don't persist any cursor attribute
        clone.setStrokeAndFill( this.getZoneColor() ); // change the color to persist, in case it was overwritten (eg by consult group )

        return clone;

    },
    /*
    * Called from view.renderFromModel (model > el)
    * Adjusts for scale, rotation ... no dpi, conversion coordinate)
    * */
    getPathToRenderFromModel: function(scale) {

        var pg = this.pageModel;

        return Raphael.fn.viewerAdjustedPath(
            this.origSVGAttrs.path,
            scale,
            pg.get('rotation'),
            pg.getOriginalCenterPtRotated(scale) //don't need if rotation
        );

    },

    /**
     * Note: not using the central getAttributesToApplyToShapeEl ...
     */
    getNonPathInactiveSVGAttrs: function( canvasChannel ) {

        var attrs = _.omit( this.origSVGAttrs, 'path' );

        var color = canvasChannel.request( 'getColorToApplyToShape', this.parentNote, this, false );

        if (color) {
            attrs.fill && attrs.fill !== 'none' && ( attrs.fill = color );
            attrs.stroke && attrs.stroke !== 'none' && ( attrs.stroke = color );
        }

        return attrs;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/graphic.js
 ** module id = 295
 ** module chunks = 0
 **/